import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { NotifyOutsideClick } from 'core/components';
import { BaasicSelect, Loader, DatePicker } from 'core/components';
import { dateFilterOptions } from 'common/constants';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const OrderDateRangeFilterTemplate = ({
	orderDateRangeViewStore: {
		form,
		loading,
		selectedDateFilterOption,
		onDateSelect,
		dateFormat,
		onDateInput,
		customDateRange,
		closeCustomDateRange,
	},
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<div className="flex--primary flex--align--middle pos--rel spc--right--med h--50">
			<BaasicSelect
				options={dateFilterOptions}
				value={
					selectedDateFilterOption.value != 'None'
						? selectedDateFilterOption
						: t('ORDERVIEW.PLACEHOLDER.DATERANGESELECT')
				}
				isClearable={false}
				isSearchable={false}
				onChange={onDateSelect}
				placeholder={t('ORDERVIEW.PLACEHOLDER.DATERANGESELECT')}
				orderBy={'id'}
				className="w--200--px"
			/>
			{customDateRange && (
				<NotifyOutsideClick action={() => closeCustomDateRange()}>
					<div className="header__profile--csv">
						<div className={'header__profile--dropdown' + (customDateRange ? ' active' : '')}>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('dateRangeStart')} format={dateFormat} />
							</div>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('dateRangeEnd')} format={dateFormat} />
							</div>
							<div className="type--right">
								<Button
									className="btn btn--med btn--secondary"
									onClick={() => onDateInput()}
									type="button"
									disabled={
										form.$('dateRangeStart').value == '' ||
										form.$('dateRangeStart').value === undefined ||
										form.$('dateRangeEnd').value == '' ||
										form.$('dateRangeEnd').value === undefined ||
										!moment(form.$('dateRangeStart').value).isValid() ||
										!moment(form.$('dateRangeEnd').value).isValid()
									}
								>
									{t('SEARCH')}
								</Button>
							</div>
						</div>
					</div>
				</NotifyOutsideClick>
			)}
		</div>
	);
};

export default defaultTemplate(OrderDateRangeFilterTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderDateRangeFilterTemplate.jsx